module.exports = __webpack_public_path__ + "static/img/04.8618544a.jpg";